export default {
    activateuser: {
        headerLabel: 'Incorporación de usuarios',
        accountActivation: 'Activación de la cuenta',
        step1: {
            header: '¡Bienvenido a nuestra plataforma!',
            subHeader: 'Elija cómo quiere conectarse a su cuenta',
            description:
                'Para un proceso de inicio de sesión más sencillo, le recomendamos que conecte su cuenta con al menos uno de los siguientes servicios.',
            OR: 'o',
            emailAndPassword: 'Utilice su propio correo electrónico',
        },
        step2: {
            header: 'Utilizar el correo electrónico y la contraseña',
            description:
                'Este es el correo electrónico principal que se asociará a su cuenta. Le recomendamos que utilice un correo electrónico diferente al de su universidad para poder mantener el acceso a sus datos después de graduarse. Puede controlar fácilmente qué correos electrónicos recibe de nosotros en la configuración de su cuenta.',
            invalidEmail: 'El correo electrónico proporcionado no es un correo electrónico válido.',
            passwordsNotMatch: 'Las contraseñas deben coincidir',
            passwordDescription01:
                'Para garantizar la seguridad de su cuenta, debe establecer una nueva contraseña. Por favor, cree una contraseña con lo siguiente:',
            passwordDescription02: 'Un mínimo de 8 caracteres',
            passwordDescription03: 'Al menos un carácter en minúscula (a-z)',
            passwordDescription04: 'Al menos un carácter en mayúscula (A-Z)',
            passwordDescription05: 'Al menos un número o símbolo especial (0-9, !#$ etc)',
            passwordDescription06: 'Al menos 6 caracteres únicos',
            repeatPassword: 'Repetir la contraseña',
        },
        step3: {
            header: 'Activar el usuario',
            loadingHints: {
                0: 'Cargar los datos del usuario',
                1: 'Preparando todo',
                2: 'Nuevas posibilidades a la vuelta de la esquina',
                3: '¡Casi listo!',
            },
            successHeader: '¡Su cuenta ya está lista para funcionar!',
            successSubheader: '¡Ya puede acceder a funciones exclusivas!',
            errorHeader: 'No se ha podido activar la cuenta',
            ifWrongContact:
                'Si cree que es un error, póngase en contacto con el servicio de asistencia',
            contactForHelp: 'Contacto para ayuda',
            goBack: 'Volver',
        },
    },
    assessments: {
        general: {
            checkMyProgress: 'Comprobar mi progreso',
            getStarted: 'Comenzar',
            getToKnowYourself: 'Conózcase a sí mismo',
            getToKnowYourselfBold: 'Conózcase <strong>yourself</strong>',
            getToKnowYourFuture: 'Conozca su futuro',
            getToKnowYourFutureBold: 'Conozca su <strong>future</strong>',
            openAssessments: 'Evaluaciones abiertas',
            openAssessment: 'Evaluación abierta',
            unlock: 'Desbloquee las pruebas',
            testYourself: 'Póngase a prueba',
            takeTheFreeTests: 'Realice las pruebas gratuitas',
            youOwnThisProduct: 'Usted es dueño de este producto',
            startTest: 'Empezar la prueba',
            startTests: 'Comenzar las pruebas',
            continue: 'Continuar',
            showReport: 'Mostrar informe',
            showYourReports: 'Mostrar sus informes',
            showYourReport: 'Mostrar su informe',
            continueFreeTests: 'Continuar las pruebas gratuitas',
            continueTheTest: 'Continuar la prueba',
            estimatedTime: '~ {min} min',
        },
        landing: {
            section1: {
                title: 'Póngase a prueba',
                description01:
                    'Bienvenido al Centro de Evaluaciones: aquí es donde comienza su viaje profesional.',
                description02:
                    'Aquí es donde puede realizar las <strong>Aon Assessments</strong>, pruebas utilizadas por los reclutadores de todo el mundo, que comprueban su aptitud y preparación para una futura carrera.',
                freemium: {
                    description:
                        'Realice estas pruebas para medir sus puntos fuertes y obtener informes eficaces de sus habilidades.',
                    price: 'Gratis',
                    numTests: '3 pruebas',
                    timeEstimated: '27 minutos aprox.',
                },
                premium: {
                    description:
                        'Este es el <strong>real deal</strong>. Realice esta prueba 3 en 1 para averiguar qué trayectorias profesionales debe seguir y obtenga un informe completo del candidato.',
                    numTests: 'Prueba  3 en 1',
                    timeEstimated: 'Aproximadamente 60 minutos',
                    sampleReport: '↓Descargue el informe de muestra',
                    candidateReport: 'Informe del candidato',
                    candidateReportDescription:
                        'Una vez que termine estas pruebas, obtendrá un Informe del Candidato completo con una visión general de sus resultados que incluye consejos para mejorar su conjunto de habilidades personales, a qué habilidades debería prestar atención, las mejores oportunidades para empezar, cuál debería ser su siguiente paso y mucho más.',
                },
            },
            section2: {
                title: '¿Cómo le ayudarán estas pruebas a ser contratado?',
                t1: 'Conocerá sus <strong>skills</strong>',
                t2: 'Se dará cuenta de su <strong>potential</strong>',
                t3: 'Tendrá un <strong>career path</strong> claro',
                t4: 'Aumentará su <strong>confidence</strong>',
            },
            section3: {
                title: 'Conocerá sus puntos fuertes personales y sus oportunidades profesionales para impulsar su desarrollo y su progresión profesional.',
            },
            section4: {
                title: 'Adelántese a sus competidores hoy mismo',
                description:
                    'completando las evaluaciones utilizadas por los reclutadores de todo el mundo en empresas como Deloitte, Siemens, Burger King, Vodafone o P&G.',
            },
            section5: {
                title: 'Preguntas frecuentes',
                thisPage: 'esta página',
                question01: {
                    q: '¿Qué son las evaluaciones de Aon?',
                    a: 'Las evaluaciones de talento de Aon son pruebas reconocidas mundialmente que ayudan a las empresas de todo el mundo a identificar a los mejores candidatos para un puesto de trabajo. Con la ayuda de las evaluaciones de talento, los reclutadores pueden mirar más allá de los CV, las notas escolares, los certificados de estudios y los diplomas universitarios para saber si un candidato es una buena opción.\n                <br><br>\n                Estas soluciones suelen estar reservadas <strong>for recruiters only</strong> – aquí, usted tiene una <strong>exclusive</strong> de practicar y obtener sus resultados antes de su entrevista de trabajo. La mayoría de los candidatos no tienen esta oportunidad, ¡así que aprovéchela!',
                },
                question02: {
                    q: '¿Tengo que pagar para hacer estas evaluaciones?',
                    a: 'Puede realizar 4 de estas pruebas de forma gratuita – <i>Work-related Behavior</i>, <i>Numerical Reasoning</i>, <i>Deductive-logical Thinking</i>, and <i>Inductive-logical Reasoning</i>. Estas pruebas miden sus habilidades y aptitudes y son una excelente manera de averiguar sus puntos fuertes y débiles.\n\n                <br><br>Sin embargo, si desea tener una visión completa de sus predisposiciones, obtener información profesional sobre sus trayectorias profesionales más adecuadas y dar un gran paso hacia su éxito futuro, también puede acceder a la prueba 3 en 1 y obtener un informe completo del candidato por €79. <br><br>Para el acceso ampliado, sólo tiene que <a href={premiumLink}>click here</a> y pagar con tarjeta – utilizamos un método de pago seguro.\n                ',
                },
                question03: { q: '¿Por qué debo hacer estas pruebas?' },
                question04: {
                    q: '¿Cómo puedo prepararme para estas pruebas?',
                    a: 'Puede leer todo sobre los requisitos técnicos y cómo prepararse para las evaluaciones en <a href={link} target="_blank">this page</a>. Allí también encontrará materiales que le ayudarán a superarlo',
                },
                question05: {
                    q: '¿Dónde puedo encontrar estas evaluaciones?',
                    a: 'Normalmente, su reclutador le pedirá que complete estas pruebas – aparte de eso, no las encontrará disponibles para usted en ningún otro lugar. Se trata de una oportunidad exclusiva para que practique, descubra más sobre usted mismo y sobre su futura carrera.',
                },
                question06: {
                    q: '¿Cuántas veces puedo hacer las pruebas?',
                    a: 'Solo puede tomar una vez cada prueba, no hay repeticiones. Asegúrese de estar en condiciones de realizarla para aprovechar al máximo esta oportunidad. Puede familiarizarse con la prueba viendo vídeos de instrucción y haciendo un ejercicio de práctica antes de realizarlo.',
                },
                question07: {
                    q: '¿En qué idioma se realizan estas pruebas?',
                    a: '\n               El idioma por defecto de estas pruebas es el Inglés, sin embargo, cada una de ellas tiene una variedad de idiomas para elegir. Puede comprobar qué idiomas están disponibles y elegir el que más le convenga antes de realizar la prueba. \n                ',
                },
                question08: {
                    q: '¿Hay una fecha de caducidad en las pruebas ampliadas una vez que las pago?',
                    a: 'No. Una vez aceptado su pago, puede realizar las pruebas ampliadas cuando quiera. Tómese su tiempo para prepararse y comience las evaluaciones en el momento que más le convenga.',
                },
            },
        },
        center: {
            banner: {
                title: 'Compruebe su progreso',
                subtitle: 'Aquí tiene un resumen de su progreso en las evaluaciones profesionales',
                moreInfo: 'Más información',
                yourProgress: 'Su progreso',
                quote: 'Establecer objetivos es el primer paso para convertir lo invisible en visible.',
            },
            list: {
                timeEstimated: 'aprox. {minutes} min',
                freemium: {
                    intro: '\n                    ¡Este es el primer paso en su viaje de desarrollo personal! <br />\n                    Realice estas pruebas para medir sus puntos fuertes y obtener informes eficientes de sus\n                    habilidades.\n    ',
                },
                premium: {
                    intro: '\n                    Esta es la verdadera oportunidad.<br />\n                    Realice estas pruebas para averiguar qué trayectorias profesionales debe seguir y obtenga un\n                    <strong>Candidate Report</strong> completo.\n              ',
                    description:
                        '\n                    Su <strong>Candidate Report</strong> le ofrecerá una visión global\n                    completa de sus resultados, incluyendo <strong>tips</strong> para mejorar su\n                     conjunto de habilidades personales, a qué <strong>habilidades</strong> debe prestar atención, las\n                    mejores <strong>opportunities</strong> para empezar, cuál debe ser su\n                    <strong>next step</strong>, y mucho más.\n            ',
                },
            },
            instruments: {
                344: {
                    name: 'Pensamiento Lógico-deductivo',
                    description:
                        'Compruebe lo bueno que es con el uso de los conocimientos y la aplicación de las reglas – esta prueba mide su capacidad analítica y de resolución de problemas.',
                    estimatedTime: '9',
                },
                383: {
                    name: 'Razonamiento Lógico-inductivo',
                    description:
                        '¿Qué tan bien puede identificar las reglas y las interrelaciones? Compruébelo con esta prueba que mide su capacidad de análisis y de resolución de problemas.',
                    estimatedTime: '9',
                },
                390: {
                    name: 'Comportamiento en el Trabajo',
                    description:
                        '¿Qué tipo de rasgos de personalidad laboral tiene? Descúbralo realizando esta prueba que identifica sus características de personalidad en el trabajo.',
                    estimatedTime: '30',
                },
                721: {
                    name: 'Razonamiento Numérico',
                    description:
                        '¿Qué tal se le da hacer números? Esta prueba mide su comprensión de la información numérica y la obtención de conclusiones lógicas.',
                    estimatedTime: '9',
                },
                5392: {
                    name: 'Memoria de Trabajo',
                    description:
                        '¿Qué tan bien puede mantenerse concentrado? Esta prueba mide la capacidad de procesar y recordar información en entornos de distracción.',
                    estimatedTime: '15',
                },
                82013: {
                    name: 'Prueba de flexión',
                    description:
                        '¿Cuáles son sus intereses? Este cuestionario le ayudará a determinar que carreras quiere seguir.',
                    estimatedTime: '15',
                },
            },
        },
        dialog: {
            header: 'Inicie sus evaluaciones con Aon',
            consent:
                'Entiendo que Aon es responsable de mis datos relacionados con esta evaluación, y acepto sus términos y condiciones.\n                También acepto que Highered pueda transferir mi nombre a Aon para generar mi informe.',
            startTest: 'Iniciar prueba',
            consentErrorTitle: 'Error de consentimiento',
            consentErrorMessage:
                'Algo ha ido mal al enviar su consentimiento. ¿Ha confirmado su correo electrónico?',
        },
    },
    "<br><br>\\n           Premier - vous arrivez préparé avec une partie du processus de recrutement déjà effectuée, ce qui vous fera instantanément prendre de l'avance sur les autres candidats":
        {
            '\\n            <br><br>\\n Deuxième - vous abordez votre recrutement avec un esprit clair':
                {
                    " Vous connaissez vos points forts et ce que l'avenir vous réserve - motivation instantanée et véritable regain de confiance garantis! Les recruteurs pourront le dire":
                        {
                            '"': '\\ n Ang mga rekruter sa buong mundo ay gumagamit ng Mga Pagsusuri sa Pagsusuri ng AON sa kanilang proseso ng pagpili ng kandidato. Sa pamamagitan ng pagkumpleto ng mga ito nang maaga at pagpapakita sa kanila ng mga handa na ulat, makakakuha ka ng isang mahusay na pagkakataon upang tunay na humanga ang mga nagrekrut. Paano? \\ n <br> <br> \\ n Una - handa kang maghanda kasama ang bahagi ng proseso ng pangangalap na tapos na, na agad na tatalon ka sa ibang mga kandidato. \\ n <br> <br> \\ n Pangalawa - lalapit ka sa iyong pangangalap na may malinaw na isip. Alam mo ang iyong mga kalakasan at kung ano ang hinaharap para sa iyo - instant pagganyak at isang wastong boost boost ng kumpiyansa! Masasabi iyon ng mga nagrekrut.',
                        },
                },
        },
    calendar: {
        header: 'Calendario',
        myCalendar: 'Mi calendario',
        noCalendar: 'Su servicio de carrera aún no ha activado la función de calendario.',
        goBackBtn: 'Volver',
        calendarNotReady: 'La funcionalidad "mi calendario" aún no está lista. Pronto',
        noUpcomingAppointments: 'No tiene ninguna cita próxima.',
        appointmentMissing: 'Cita no activa',
        appointmentNotActive:
            'Lo sentimos, ha intentado ver una cita que no existe o no está activa.',
        appointmentNotHavingAvailability:
            'Lo sentimos, esta cita no tiene disponibilidad en este momento. Vuelva a comprobarlo más tarde.',
        appointmentMissingRules: 'La cita no tiene disponibilidad',
        needToCompleteProfile: 'Complete su perfil',
        noUpcomingAppointmentsPleaseBook: 'Reserve una cita para desbloquear su calendario.',
        bookAppointment: 'Reservar cita',
        bookAnotherAppointment: 'Reservar una cita',
        attendedAppointments: 'Citas a las que ha asistido',
        aboutAppointments: {
            header: 'Acerca de las citas',
            button: 'Acerca de',
            block1: {
                header: '¿Qué es una cita?',
                paragraph1:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                paragraph2:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            },
            block2: {
                header: '¿Con quién puedo ponerme en contacto para obtener más información?',
                paragraph1:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                paragraph2:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            },
        },
        bookAnAppointment: 'Reservar una Cita',
        backToCalendarBtn: 'Volver al calendario',
        backToBookingBtn: 'Volver a la lista de citas',
        firstAvailable: 'Primera cita disponible',
        loadingAppointment: 'Cargando ...',
        bookModal: {
            title: 'Confirmar reserva',
            with: 'Con',
            confirm: 'Confirmar',
            continue: 'Continuar',
            cancel: 'Cerrar',
            first: {
                title: 'Esta es su primera cita',
                description:
                    'Para asegurarse de que recibe la invitación al evento, confirme que tiene acceso a un calendario personal a través de esta cuenta de correo electrónico',
                ok: 'OK',
                wrongEmail: '¿Está equivocado el correo electrónico?',
            },
            changeEmail: {
                title: 'Seleccione el correo electrónico de su calendario',
                inputPlaceholder: 'Escriba el correo electrónico ...',
                ok: 'OK',
                back: 'Usar el predeterminado',
            },
            unknownErrorHeader: 'Se ha producido un error al intentar reservar',
            unknownErrorBody:
                'Por favor, intente reservar en otro momento, y si esto no funciona contacte, al servicio de asistencia.',
            confirmationHeader: '¡Su cita está reservada!',
            bookedTheFollowing: 'Detalles:',
            emailWillBeSent: 'Se enviará un correo electrónico a',
            withConfirmation: 'pidiéndole que confirme su asistencia.',
        },
        dateDetailsModal: { title: 'Citas en' },
        completedYourProfile: 'Debe completar su perfil para tener acceso al sistema de calendario',
        toMyProfile: 'Editar mi perfil',
    },
    chat: {
        profileSharingConfirmDialog: {
            title: '{name} quiere ver su perfil',
            content: '¿Quiere compartir su perfil con esta persona?',
            share: 'Compartir perfil',
            reject: 'No',
        },
    },
    companyDetail: {
        locations: {
            header: 'Ubicaciones',
            viewAll: 'Ver todas',
            noLocations: 'No hay ubicaciones',
            allLocations: 'Todos los puestos',
        },
        jobModule: {
            header: 'Puestos principales',
            viewAllJobs: 'Ver todos los puestos de trabajo de {companyName}',
            noPositions: '{companyName} actualmente no tiene ninguna posición abierta en Highered.',
            defaultLabel: 'Puestos abiertos',
        },
        videos: {
            header: 'Vídeos',
            noVideos: 'No hay vídeos',
            noMoreVideos: 'No hay más vídeos',
            moreVideosFrom: 'Más vídeos de {companyName}',
        },
        articles: {
            header: 'Artículos',
            noArticles: 'No hay artículos',
            noMoreArticles: 'No hay más artículos',
            moreArticlesFrom: 'Más artículos de {companyName}',
        },
    },
    components: {
        builders: {
            searchable: { create: 'Crear ' },
            yearMonthPicker: { defaultSelect: 'Seleccione un mes' },
            localeDropdown: {
                languages: { en: 'Inglés', cn: 'Chino', fr: 'Francés' },
            },
        },
        miscellaneous: {
            verifyModule: {
                title: 'Verifique el correo electrónico de su escuela',
                description:
                    'Es un proceso rápido y le dará acceso a\n                             funciones exclusivas como ofertas de empleo únicos, pruebas de habilidades\n                            y recursos profesionales.',
                verificationPending: 'Verificación pendiente',
                weHaveSentAnEmail:
                    ' Hemos enviado un correo electrónico a \n                                <strong>{studentEmail}</strong> for\n                                 para que se verifique. Asegúrese de\n                                revisar su carpeta de correo no deseado, ya que muchas escuelas son\n                                bastante estrictas con los correos electrónicos entrantes.',
                verifyMe: 'Verificarme',
                resendVerifyEmail: 'Reenviar el correo de verificación',
                cancelVerification: 'Cancelar la verificación',
                emailSent: 'Correo electrónico enviado',
                emailSentMessage:
                    'El correo electrónico se ha enviado con éxito. Si no lo recibe, póngase en contacto con nosotros en support@highered.global.',
                resendErrorTitle: 'Error durante el reenvío del correo electrónico',
                resendErrorMessage:
                    'No se ha podido reenviar el correo electrónico de verificación. Por favor, póngase en contacto con nosotros en support@highered.global.',
                verificationCancelledTitle: 'Verificación cancelada',
                verificationCancelledMessage: 'La verificación se ha cancelado con éxito.',
                cancelErrorTitle: 'Error durante la cancelación',
                cancelErrorMessage:
                    'No se ha podido cancelar la verificación. Por favor, póngase en contacto con nosotros en support@highered.global.',
            },
            verifyModuleDialog: {
                title: 'Verifique el correo electrónico de su institución académica',
                university: 'Institución académica',
                studentEmail: 'Su correo electrónico académico',
                studentEmailPlaceholder: 'Correo electrónico académico',
                message: 'Mensaje',
                verify: 'Verificar',
                sendRequest: 'Enviar solicitud',
                verificationInProcess: 'Verificación en proceso',
                emailHasBeenSentTo:
                    'Se ha enviado un correo electrónico a <strong>{email}</strong>. Siga las instrucciones que aparecen allí para verificar su conexión con <strong>{schoolName}</strong>',
                verificationRequestSentNonAcademic:
                    'Los servicios de carrera de <strong>{schoolName}</strong> tendrán que verificar su conexión. Se le notificará por correo electrónico cuando esto ocurra.',
                ifNoEmailRecieved:
                    'Si no ha recibido el correo de verificación, póngase en contacto con nosotros.',
                contactHelp: 'Póngase en contacto con nosotros para obtener ayuda',
                doNotHaveAcademicEmail: 'No tengo una dirección de correo electrónico académica',
                doubleCheckEmail:
                    'Por favor, compruebe que esta dirección de correo electrónico es correcta y que tiene acceso a ella.',
                haveAcademicEmail: 'Tengo una dirección de correo electrónico académica',
                noAcademicEmailInfo:
                    'Si no utiliza una dirección de correo electrónico académica, su solicitud deberá ser aprobada manualmente por los servicios de carrera. Por lo tanto, deberá proporcionar un breve mensaje para identificarse.',
                alreadyVerifiedInfo: 'Ya está verificado en esta escuela.',
            },
        },
        navigation: {
            navigation: {
                myPage: 'Mi página',
                jobs: 'Empleos',
                companies: 'Empresas',
                masterclasses: 'Clases magistrales',
                assessments: 'Evaluaciones',
                countryGuides: 'Guías de países',
                goToHaigui: 'Trabajos en China',
                signIn: 'Iniciar sesión / Registrarse',
                vfairs: 'Eventos virtuales',
                events: 'Eventos',
                newFeature: '¡Nueva función!',
            },
            profileNavigation: { signOut: 'Cerrar la sesión' },
            sidebar: {
                myPage: 'Mi página',
                myProfile: 'Mi perfil',
                findJobs: 'Encontrar trabajos',
                findCompanies: 'Buscar empresas',
                masterclasses: 'Clases magistrales',
                assessments: 'Evaluaciones',
                countryGuides: 'Guías de países',
                goToHaigui: 'Trabajos en China',
                virtualFairs: 'Eventos virtuales',
                logOut: 'Cerrar sesión',
            },
            backToCalendar: 'Volver al calendario',
            allBooths: 'Todos los stands',
            home: 'Inicio',
        },
        smart: {
            companyModule: {
                followJob: 'Añadir a favoritos',
                followCompany: 'Seguir a la empresa',
                unFollowJob: 'Eliminar de los favoritos',
                unFollowCompany: 'Dejar de seguir a la empresa',
                favoritedTitle: 'Guardado en favoritos',
                favoritedMessage:
                    'Este puesto se ha guardado en sus favoritos. Encuentre sus puestos favoritos en mi página.',
                unfavoritedTitle: 'Eliminado de los favoritos',
                unfavoritedMessage: 'Este puesto ha sido eliminado de sus favoritos.',
                favoriteErrorTitle: 'Algo salió mal',
                favoriteErrorMessage: 'No se ha podido marcar este puesto como favorito',
                showAllCompanies: 'Mostrar todas las empresas',
                showOnlyCompaniesLiveOnChat: 'Mostrar sólo las empresas en vivo en el chat',
            },
            profileModule: {
                profileCompletion: 'Completar el perfil',
                profileCompletionEncouragement:
                    'Muéstrese a los empleadores completando el último {percentageLeft} de su perfil',
                gotoProfilePage: 'Actualizar el perfil',
                profileCompleted: 'Perfil completado',
                profileCompletedWhatsNext:
                    '¿Sabía que la mayoría de los empleadores utilizan evaluaciones en línea en sus procesos de contratación? Practique ahora y obtenga información sobre sus puntos fuertes y débiles.',
                gotoTestsPage: 'Ir al centro de evaluación',
                authIndication: {
                    title: 'Encuentre el trabajo de sus sueños',
                    description:
                        '¿Desea acceder a puestos de trabajo exclusivos de su escuela y a pruebas que potencien su búsqueda de empleo? Cree fácilmente un usuario con Google, LinkedIn o Facebook hoy mismo.',
                    action: 'Vamos',
                },
                toProfileHint: 'A mi perfil',
                toProfileUncompletedHint:
                    'Su perfil no está completo al 100%. Por favor, proceda a completarlo para maximizar su empleabilidad.',
                profileActions: {
                    addFirstName: 'Añadir nombre',
                    addLastName: 'Añada el apellido',
                    addNationality: 'Añada su nacionalidad',
                    addPhoneNumber: 'Añada su número de teléfono',
                    addLanguage: 'Añada un idioma',
                    addEducation: 'Añada una educación',
                    addEmail: 'Añada su correo electrónico',
                    addGender: 'Añada su sexo',
                },
            },
            featuredCompanies: { label: 'Empresas destacadas' },
            featuredPositions: { label: 'Puestos destacados' },
            featuredResource: {
                header: 'Únase a la conferencia virtual',
                cta: '¡Vea ahora!',
                wechatSignupHeader:
                    'Siga la cuenta WeChat de Highered para recibir actualizaciones',
            },
        },
    },
    cts: {
        filterNames: {
            employment_types: 'Tipos de empleo',
            education_level: 'Titulaciones',
            job_category: 'Campos',
            address: 'Ubicaciones',
            sector: 'Sectores',
            exclude_school_id: 'Excluya',
            languages: 'Idiomas',
        },
        excludeSchoolIds: {
            '-1': 'Puestos compartidos',
            unknownSchoolId: 'Socio de la escuela EFMD',
        },
        educationLevels: {
            BACHELORS_OR_EQUIVALENT: 'Licenciados',
            MASTERS_OR_EQUIVALENT: 'Másteres',
            DOCTORAL_OR_EQUIVALENT: 'PHD',
            MBA_OR_EQUIVALENT: 'MBA',
            DBA_OR_EQUIVALENT: 'DBA',
        },
        employmentTypes: {
            FULL_TIME: 'Tiempo completo',
            INTERN: 'Prácticas profesionales',
            TEMPORARY: 'A tiempo parcial',
            PART_TIME: 'A tiempo parcial',
        },
        startDate: 'Inicio',
        educationFields: {
            ACCOUNTING_AND_FINANCE: 'Contabilidad y finanzas',
            ADMINISTRATIVE_AND_OFFICE: 'Administración y oficina',
            ADVERTISING_AND_MARKETING: 'Publicidad y marketing',
            ART_FASHION_AND_DESIGN: 'Moda y diseño artístico',
            BUSINESS_OPERATIONS: 'Operaciones comerciales',
            COMPUTER_AND_IT: 'Informática y TI',
            CUSTOMER_SERVICE: 'Servicio al cliente',
            EDUCATION: 'Educación',
            HEALTHCARE: 'Sanidad',
            HUMAN_RESOURCES: 'Recursos humanos',
            INSTALLATION_MAINTENANCE_AND_REPAIR: 'Mantenimiento y reparación de instalaciones',
            LEGAL: 'Legal',
            MANAGEMENT: 'Gestión',
            MANUFACTURING_AND_WAREHOUSE: 'Fabricación y almacén',
            MEDIA_COMMUNICATIONS_AND_WRITING: 'Comunicación y redacción de medios de comunicación',
            OIL_GAS_AND_MINING: 'Energía',
            PROTECTIVE_SERVICES: 'Servicios de protección',
            REAL_ESTATE: 'Inmobiliaria',
            SALES_AND_RETAIL: 'Ventas y comercio minorista',
            SCIENCE_AND_ENGINEERING: 'Ciencia e ingeniería',
            SOCIAL_SERVICES_AND_NON_PROFIT: 'Servicios sociales y sin ánimo de lucro',
            TRANSPORTATION_AND_LOGISTICS: 'Transporte y logística',
        },
        sectors: {
            Consulting: 'Consultoría',
            'Consumer Goods': 'Bienes de consumo',
            'Financial Services / Banking': 'Servicios financieros / Banca',
            'Goverment / Public Administration / Non Profit':
                'Gobierno / Administración Pública / Sin ánimo de lucro',
            'International Trade & Development': 'Comercio internacional y desarrollo',
            Manufacturing: 'Fabricación',
            'Media / Entertainment': 'Medios de comunicación / Entretenimiento',
            'Petroleum / Energy': 'Petróleo / Energía',
            'Pharma / Healthcare / Biotech': 'Farmacia / Sanidad / Biotecnología',
            'Real Estate / Construction / Infrastructure':
                'Inmobiliaria / Construcción / Infraestructura',
            'Technology (IT) / Telecom': 'Tecnología (TI) / Telecomunicaciones',
            'Transportations & Logistics': 'Transportes y logística',
            Other: 'Otros',
        },
        countries: {
            'China (Hong Kong SAR)': 'Hong Kong',
            'Costa Rica': 'Costa Rica',
            'Europe & Sub-Saharan Africa': 'Europa y África subsahariana',
            'Hong Kong': 'Hong Kong',
            'Korea, South': 'Corea del Sur',
            'New Zealand': 'Nueva Zelanda',
            'Papua-Ny Guinea': 'Papúa Nueva Guinea',
            'Puerto Rico': 'Puerto Rico',
            'Saudi Arabia': 'Arabia Saudí',
            'South Africa': 'Sudáfrica',
            'South Korea': 'Corea del Sur',
            'Sri Lanka': 'Sri Lanka',
            'Taiwan (Province of China)': 'Taiwán',
            'The Seychell Islands': 'Seychelles',
            'United Arab Emirates': 'Emiratos Árabes Unidos',
            'United Kingdom': 'Reino Unido',
            'Ivory Coast': 'Costa de Marfil',
            Afghanistan: 'Afganistán',
            Algeria: 'Argelia',
            Angola: 'Angola',
            Argentina: 'Argentina',
            Armenia: 'Armenia',
            Australia: 'Australia',
            Austria: 'Austria',
            Azerbaijan: 'Azerbaiyán',
            Bahamas: 'Bahamas',
            Bahrain: 'Bahrein',
            Bangladesh: 'Bangladesh',
            Belarus: 'Bielorrusia',
            Belgium: 'Bélgica',
            Botswana: 'Botsuana',
            Brazil: 'Brasil',
            Bulgaria: 'Bulgaria',
            Cambodia: 'Camboya',
            Canada: 'Canadá',
            Chile: 'Chile',
            China: 'China',
            Colombia: 'Colombia',
            Congo: 'Congo',
            Croatia: 'Croacia',
            Cyprus: 'Chipre',
            Czechia: 'Checa',
            Denmark: 'Dinamarca',
            Ecuador: 'Ecuador',
            Egypt: 'Egipto',
            Estonia: 'Estonia',
            Ethiopia: 'Etiopía',
            Fiji: 'Fiji',
            Finland: 'Finlandia',
            France: 'Francia',
            Germany: 'Alemania',
            Ghana: 'Ghana',
            Greece: 'Grecia',
            Guernsey: 'Guernsey',
            Hungary: 'Hungría',
            Iceland: 'Islandia',
            India: 'India',
            Indonesia: 'Indonesia',
            Iraq: 'Irak',
            Ireland: 'Irlanda',
            Israel: 'Israel',
            Italy: 'Italia',
            Japan: 'Japón',
            Jersey: 'Jersey',
            Jordan: 'Jordania',
            Kazakhstan: 'Kazajstán',
            Kenya: 'Kenia',
            Kuwait: 'Kuwait',
            Laos: 'Laos',
            Latvia: 'Letonia',
            Lebanon: 'Líbano',
            Lithuania: 'Lituania',
            Luxembourg: 'Luxemburgo',
            Malaysia: 'Malasia',
            Malta: 'Malta',
            Mauritania: 'Mauritania',
            Mauritius: 'Mauricio',
            Mexico: 'México',
            Mongolia: 'Mongolia',
            Morocco: 'Marruecos',
            Myanmar: 'Myanmar',
            Namibia: 'Namibia',
            Netherlands: 'Países Bajos',
            Nigeria: 'Nigeria',
            Norway: 'Noruega',
            Oman: 'Omán',
            Pakistan: 'Pakistán',
            Panama: 'Panamá',
            Paraguay: 'Paraguay',
            Peru: 'Perú',
            Philippines: 'Filipinas',
            Poland: 'Polonia',
            Portugal: 'Portugal',
            Qatar: 'Qatar',
            Romania: 'Rumanía',
            Russia: 'Rusia',
            Senegal: 'Senegal',
            Serbia: 'Serbia',
            Singapore: 'Singapur',
            Slovakia: 'Eslovaquia',
            Slovenia: 'Eslovenia',
            Spain: 'España',
            Sudan: 'Sudán',
            Swaziland: 'Suazilandia',
            Sweden: 'Suecia',
            Switzerland: 'Suiza',
            Syria: 'Siria',
            Taiwan: 'Taiwán',
            Tanzania: 'Tanzania',
            Thailand: 'Tailandia',
            Tonga: 'Tonga',
            Turkey: 'Turquía',
            Ukraina: 'Ucrania',
            Ukraine: 'Ucrania',
            USA: 'EE.UU.',
            Uzbekistan: 'Uzbekistán',
            Vanuatu: 'Vanuatu',
            Vietnam: 'Vietnam',
            Zambia: 'Zambia',
        },
        languages: {
            Aceh: 'Aceh',
            Afrikaans: 'Afrikaans',
            Albanian: 'Albanés',
            Amharic: 'Amárico',
            Arabic: 'Árabe',
            Arakanese: 'Arakanés',
            Armenian: 'Armenio',
            Azeri: 'Azerí',
            Badini: 'Badini',
            Basque: 'Vasco',
            Belarusian: 'Bielorruso',
            Bengali: 'Bengalí',
            Berber: 'Bereber',
            Bosnian: 'Bosnio',
            Bulgarian: 'Búlgaro',
            Burmese: 'Birmano',
            Cantonese: 'Cantonés',
            Catalan: 'Catalán',
            Cebuano: 'Cebuano',
            Chechen: 'Checheno',
            Chin: 'Chin',
            Chinese: 'Chino',
            Croatian: 'Croata',
            Czech: 'Checo',
            Danish: 'Danés',
            Dari: 'Dari',
            Dutch: 'Holandés',
            English: 'Inglés',
            Estonian: 'Estonio',
            Faroese: 'Feroés',
            Filipino: 'Filipino',
            Finnish: 'Finlandés',
            French: 'Francés',
            German: 'Alemán',
            Greek: 'Griego',
            Greenlandic: 'Groenlandés',
            Hausa: 'Hausa',
            Hebrew: 'Hebreo',
            Hindi: 'Hindi',
            Hungarian: 'Húngaro',
            Icelandic: 'Islandés',
            Indonesian: 'Indonesio',
            Italian: 'Italiano',
            Japanese: 'Japonés',
            Kazakh: 'Kazajo',
            Kinyarwanda: 'Kinyarwanda',
            Kirundi: 'Kirundi',
            Korean: 'Coreano',
            Kurdish: 'Kurdo',
            Kurmanji: 'Kurmanji',
            Kven: 'Kven',
            Latin: 'Latín',
            Latvian: 'Letón',
            Lingala: 'Lingala',
            Lithuanian: 'Lituano',
            Macedonian: 'Macedonio',
            Malagasy: 'Malgache',
            Malaysian: 'Malayo',
            Mandarin: 'Mandarín',
            Mongolian: 'Mongol',
            Nepali: 'Nepalí',
            Norwegian: 'Noruego',
            Oromo: 'Oromo',
            Other: 'Otros',
            Panjabi: 'Panyabí',
            Pashto: 'Pashto',
            Persian: 'Persa',
            Polish: 'Polaco',
            Portuguese: 'Portugués',
            Punjabi: 'Punjabi',
            Romanes: 'Romaní',
            Romani: 'Romaní',
            Romanian: 'Rumano',
            Russian: 'Ruso',
            Sami: 'Sami',
            Serbian: 'Serbio',
            Sign_language: 'Lengua de signos',
            Slovak: 'Eslovaco',
            Slovene: 'Esloveno',
            Somali: 'Somalí',
            Sorani: 'Sorani',
            Spanish: 'Español',
            Swahili: 'Swahili',
            Swedish: 'Sueco',
            Tagalog: 'Tagalo',
            Tamil: 'Tamil',
            Thai: 'Tailandés',
            Tigrinya: 'Tigriña',
            Turkish: 'Turco',
            Ukrainian: 'Ucraniano',
            Urdu: 'Urdu',
            Uyghur: 'Uigur',
            Vietnamese: 'Vietnamita',
            Wolof: 'Wolof',
        },
    },
    emailverification: {
        headerLabel: 'Verificación del correo electrónico',
        verifyingEmail: 'Verificación del correo electrónico',
        emailVerifySuccess: '¡Su correo electrónico ha sido verificado!',
        emailVerifyFailure:
            'Algo ha ido mal... inténtelo más tarde o póngase en contacto con el servicio de asistencia',
        gotoMyPage: 'Volver a mi página',
    },
    errors: {
        defaultErrorMessage: '¡Se ha producido un error!',
        logInErrorText: {
            invalidCredentials: 'Nombre de usuario o contraseña incorrectos',
            inactiveUser:
                'El usuario con el correo electrónico proporcionado está inactivo. Compruebe su correo electrónico para ver si la cuenta está activada o intente restablecer su contraseña.',
            default: 'No se ha podido autentificar.',
        },
        registerErrorText: {
            passwordTooShort: 'La contraseña debe tener al menos 8 dígitos.',
            emailAlreadyInUse: 'El correo electrónico proporcionado ya está en uso.',
            emailTaken:
                'El correo electrónico ya está en uso. Si ha utilizado el correo electrónico de su escuela, esto puede ocurrir porque tenía un usuario antes de que se actualizara la plataforma (en higheredtalent.org).',
            default: 'No se ha podido crear un usuario.',
        },
        invalidTokenText: { default: 'Su token no es válido o ha caducado.' },
        passwordErrorText: {
            passwordTooShort: 'La contraseña debe tener al menos 8 dígitos.',
            requireNonAlphanumeric: 'La contraseña debe contener al menos un caracter especial.',
            requireLowerCase: 'La contraseña debe contener al menos una letra minúscula.',
            requireUpperCase: 'La contraseña debe contener al menos una letra mayúscula.',
            requireUniqueChars: 'La contraseña debe contener al menos 6 caracteres diferentes',
            default: 'No se ha podido cambiar la contraseña',
        },
        recoverErrorText: {
            userNotFound:
                'El usuario no existe. Por favor, póngase en contacto con el servicio de asistencia.',
            userAlreadyActive: 'El usuario ya está activado!\nPor favor, intente conectarse.',
            emailAlreadyInUse:
                'El correo electrónico proporcionado ya está en uso.\nSi desea continuar con la activación de la cuenta, pruebe con un correo electrónico diferente o con un acceso social distinto. De lo contrario, proceda a la página de inicio y acceda a su cuenta.',
            default: 'No se ha podido activar la cuenta.\nPor favor, inténtelo más tarde.',
        },
        socialAuthErrorText: {
            errorTitle: 'No se ha podido iniciar la sesión con el {provider}',
            invalidProviderGoogle:
                'El usuario con el correo electrónico proporcionado no está conectado con Google. Por favor, intente, por ejemplo, conectarse con LinkedIn, Facebook o el correo electrónico.',
            invalidProviderFacebook:
                'El usuario con la dirección de correo electrónico proporcionada no está conectado con Facebook. Por favor, intente, por ejemplo, conectarse con Google, LinkedIn o el correo electrónico.',
            invalidProviderLinkedIn:
                'El usuario con la dirección de correo electrónico proporcionada no está conectado con LinkedIn. Por favor, intente, por ejemplo, conectarse con Google, Facebook o correo electrónico.',
            invalidProviderWeChat:
                'El usuario con la dirección de correo electrónico proporcionada no está conectado con WeChat. Por favor, intente, por ejemplo, conectarse con Google, Facebook o correo electrónico.',
        },
        uniConnErrorText: {
            emailNotAvailable:
                'El correo electrónico proporcionado ya está en uso. Esto puede deberse a que tenía un usuario antes de que se actualizara la plataforma (en higheredtalent.org). Por favor, póngase en contacto con el servicio de asistencia.',
            invalidEmailDomain:
                'El email-dominio proporcionado no coincide con la universidad proporcionada. Por favor, elija la universidad correcta.',
            existingConnection: 'El usuario ya está conectado a la universidad proporcionada',
            default: 'No se ha podido iniciar la verificación.',
        },
        spotlightErrors: {
            userUpdate: {
                emailAlreadyInUse: 'El correo electrónico ya está en uso',
                default: 'No se ha podido actualizar',
            },
        },
    },
    favorites: {
        header: 'Mis favoritos',
        active: 'Activo',
        expired: 'Caducado',
        expiresThisMonth: 'Plazo de solicitud este mes',
        expiresThisWeek: 'Plazo de solicitud esta semana',
        expiresLater: 'Plazo de solicitud más tarde',
        noActiveFavorites: 'No tiene posiciones favoritas activas',
        noExpired: 'No tiene posiciones favoritas expiradas',
    },
    findcompanies: {
        headerLabel: 'Buscar empresas',
        companyListLabel: 'Empresas',
    },
    findjobs: {
        header: 'Encontrar puestos de trabajo',
        changeFilters: 'Cambiar los filtros',
        recruitmentModule: {
            body: '¿Es usted un responsable de selección de personal, un profesional de la carrera o simplemente está\n        interesado en contratar talento estudiantil?',
            createJob: 'Haga clic aquí para crear un puesto de trabajo',
        },
    },
    general: {
        documentTitle: 'Plataforma de Oportunidades Globales',
        email: 'Correo electrónico',
        password: 'Contraseña',
        confirmPassword: 'Confirmar contraseña',
        loading: 'Cargando',
        ok: 'OK',
        save: 'Guardar',
        add: 'Añadir',
        close: 'Cerrar',
        delete: 'Borrar',
        cancel: 'Cancelar',
        done: 'Hecho',
        continue: 'Continuar',
        back: 'Volver',
        next: 'Siguiente',
        finish: 'Finalizar',
        success: 'Éxito',
        error: 'Error',
        description: 'Descripción',
        months: {
            0: 'Ene',
            1: 'Feb',
            2: 'Mar',
            3: 'Abr',
            4: 'May',
            5: 'Jun',
            6: 'Jul',
            7: 'Ago',
            8: 'Sep',
            9: 'Oct',
            10: 'Nov',
            11: 'Dic',
        },
        days: {
            0: 'Dom',
            1: 'Lun',
            2: 'Mar',
            3: 'Mié',
            4: 'Jue',
            5: 'Vie',
            6: 'Sáb',
        },
        dialogs: {
            helperTexts: {
                checkHasPendingAction: 'Comprobación de su verificación pendiente',
                verifySchoolConnection:
                    'Verificar su conexión escolar para acceder a estos recursos',
                logInToAccessMoreFeatures: 'Miles de oportunidades profesionales internacionales',
            },
        },
        minutesShort: 'min',
        poweredBy: 'Desarrollado por',
    },
    gptw: {
        company: {
            alt: 'GPTW',
            tooltip: 'Esta empresa está certificada como "Great Place To Wor',
        },
        posting: {
            label: {
                alt: 'GPTW',
                tooltip: "Este puesto pertenece a una empresa 'Great Place To Work'",
            },
            detail: {
                alt: 'GPTW',
                tooltip: {
                    isCertified:
                        "{companyName} es una empresa certificada como 'Great Place To Work'",
                    description:
                        'Lorem ipsum dolor sit amet, conextetur adipiscing elit. Sed fingilla pretium nunv, non vestibulum tellus imperdiet sed.',
                    readMore: 'Haga clic para leer más',
                },
            },
        },
    },
    jobdetail: {
        detailModule: {
            deadline: 'Plazo de solicitud',
            location: 'Ubicación',
            employmentType: 'Tipo de empleo',
            languageRequirements: 'Requisitos de idioma',
            workPermitRequirements: 'Requisitos del permiso de trabajo',
            preferredEducationField: 'Campo de educación preferido',
            preferredEducationLevel: 'Nivel educativo preferido',
            jobTags: 'Etiquetas',
            apply: 'Solicitar ahora',
            verificationRequired:
                'Necesita verificar el correo electrónico de su escuela para aplicar.',
            verificationRequiredHint:
                'Necesita verificar el correo electrónico de su escuela para aplicar.',
            verificationPending: 'Tiene una verificación pendiente en esta escuela',
            verificationPendingHint: 'Tiene una verificación pendiente en esta escuela',
        },
        invalidJobAd: {
            caption:
                'Lo sentimos, pero no hemos podido encontrar este puesto. Si cree que se trata de un error, póngase en contacto con el servicio de atención al cliente a través del siguiente chat.',
            btn: 'Encontrar otros puestos de trabajo',
        },
    },
    mypage: {
        header: 'Mi página',
        suggestedPositions: 'Puestos sugeridos',
        favoriteModule: {
            header: 'Mis puestos favoritos',
            seeAll: 'Ver todos',
            noFavorites: 'No tiene posiciones favoritas activas',
        },
    },
    recoverpassword: {
        createPassword: 'Crear una nueva contraseña',
        newPasswordLabel: 'Nueva contraseña',
        newPasswordPlaceholder: 'Contraseña',
        confirmPasswordLabel: 'Confirmar contraseña',
        confirmPasswordPlaceholder: 'Confirmar contraseña',
        resetPasswordButton: 'Restablecer contraseña',
        resettingPassword: 'Restablecer contraseña',
        passwordsNotMatching: 'Las contraseñas no coinciden.',
    },
    recoveruser: {
        headerLabel: 'Recuperar usuario superior',
        accountActivation: 'Activación de la cuenta',
        step1: {
            header: 'Bienvenido a nuestra nueva plataforma',
            subHeader: 'Elija cómo quiere conectarse a su cuenta',
            description:
                'Para un proceso de inicio de sesión más sencillo, le recomendamos que conecte su cuenta con al menos uno de los siguientes servicios.',
            OR: 'o',
            emailAndPassword: 'Utilice su propio correo electrónico',
        },
        step2: {
            header: 'Utilice el correo electrónico y la contraseña',
            description:
                'Este es el correo electrónico principal que se asociará a su cuenta. Le recomendamos que utilice una dirección de correo electrónico diferente a la de su universidad para poder mantener el acceso a sus datos después de graduarse. Puede controlar fácilmente qué correos electrónicos recibe de nosotros en la configuración de su cuenta.',
            invalidEmail: 'El correo electrónico proporcionado no es un correo electrónico válido.',
            passwordsNotMatch: 'Las contraseñas deben coincidir',
            passwordDescription01:
                'Para garantizar la seguridad de su cuenta, debe establecer una nueva contraseña. Por favor, cree una contraseña con lo siguiente:',
            passwordDescription02: 'Un mínimo de 8 caracteres',
            passwordDescription03: 'Al menos un caracter en minúscula (a-z)',
            passwordDescription04: 'Al menos un caracter en mayúscula (A-Z)',
            passwordDescription05: 'Al menos un número o símbolo especial (0-9, !#$ etc)',
            passwordDescription06: 'Al menos 6 caracteres únicos',
            repeatPassword: 'Repetir la contraseña',
        },
        step3: {
            header: 'Activar el usuario',
            loadingHints: {
                0: 'Cargar los datos del usuario',
                1: 'Preparando todo',
                2: 'Nuevas posibilidades a la vuelta de la esquina',
                3: '¡Casi listo!',
            },
            successHeader: '¡Su cuenta ya está lista para funcionar!',
            successSubheader: '¡Ya puede acceder a nuevas funciones exclusivas!',
            errorHeader: 'No se ha podido activar la cuenta',
            ifWrongContact:
                'Si cree que es un error, póngase en contacto con el servicio de asistencia',
            contactForHelp: 'Contacto para ayuda',
            goBack: 'Volver',
        },
    },
    resourcesInternal: {
        header: 'Recursos',
        resourceTypeHeader: 'Escriba',
        resourceNoContent: 'Su escuela aún no ha activado la función de recursos.',
        resourceFolderNoContent: 'No hay recursos disponibles en esta carpeta',
        resourceTitleHeader: 'Título',
        resourcePublishDateHeader: 'Publicado',
        searchPlaceholder: 'Buscar por nombre o palabra clave ...',
        cvTemplateHeader: 'PLANTILLA DE CV SUPERIOR (APTA PARA ATS)',
        cvTemplateSubtitle: '¡Descargue aquí!',
    },
    shared: {
        userNavSection: {
            myPage: 'Mi página',
            myProfile: 'Mi perfil',
            myTests: 'Evaluaciones',
            myApplications: 'Aplicaciones',
            myFavorites: 'Favoritos',
            resources: 'Recursos',
            calendar: 'Calendario',
            documents: 'Carga de CV',
        },
        searchModule: {
            searchBar: { label: 'Buscar por título o palabras clave' },
            filters: { clearFilters: 'Borrar filtros' },
            filterLimit: {
                title: 'Límite de filtros alcanzado',
                message: 'No se pueden seleccionar más filtros de este tipo',
            },
        },
        postingModule: {
            postingModule: {
                positions: 'Posiciones',
                estimatedCount: 'ca {count} de {totalCount}',
                knownCount: '{count} de {totalCount}',
                noMatchFound: 'No se ha encontrado nada que se ajuste a sus criterios',
            },
            postItem: { applyBefore: 'Plazo de solicitud' },
            postCard: { deadline: 'Fecha límite' },
        },
        loginModule: {
            emailVerificationTip: 'Puede tardar unos minutos en llegar a su bandeja de entrada.',
            noEmail: '¿No hay correo electrónico? Por favor, compruebe su filtro de spam o:',
            logIn: 'Conéctese',
            socialAuthBtns: {
                continueWithFacebook: 'Continuar con Facebook',
                continueWithGoogle: 'Continuar con Google',
                continueWithLinkedIn: 'Continuar con LinkedIn',
                continueWithWeChat: 'Continuar con WeChat',
            },
            verifyEmail: {
                verifyYourEmail: 'Por favor, verifique su correo electrónico',
                weSentAnEmailTo: 'Hemos enviado una verificación a',
                continueToSignIn: 'Continuar con el inicio de sesión',
                resendEmail: 'Reenviar enlace de verificación',
                newEmailSent: 'Se ha enviado un nuevo correo electrónico',
            },
            registerForm: {
                recommendation:
                    'Le recomendamos que utilice su correo electrónico personal y no\n            el de la escuela para asegurarse de que tiene acceso a sus datos después de\n            graduarse.',
                register: 'Registro',
                passwordsNotMatch: 'Las contraseñas no coinciden',
            },
            logInPaper: {
                useEmail: 'o utilice su correo electrónico',
                noAccount: '¿No tiene una cuenta?',
                signUp: 'Regístrese',
                logInToAccess: 'Inicie sesión para acceder a esta función',
                showAllOptions: 'Mostrar todas las opciones de inicio de sesión',
                hideAllOptions: 'Mostrar menos',
            },
            logInForm: {
                logIn: 'Iniciar sesión',
                forgotPassword: '¿Olvidó su contraseña?',
            },
            forgotPassword: {
                title: 'Petición para la recuperación de contraseña',
                description:
                    'No se preocupe - todo el mundo olvida su contraseña de vez en cuando.\n                Introduzca su correo electrónico a continuación para restablecer su contraseña',
                resetPassword: 'Restablecer la contraseña',
                emailSentTitle: '¡Su ayuda está en camino!',
                emailHasBeenSent:
                    'Se ha enviado un correo electrónico a\n                            <br>\n                            <strong>{email}</strong>\n                            <br>\n                            con instrucciones para restablecer su contraseña. Por favor, compruebe su\n                            buzón de entrada.',
                noEmail: '¿No hay correo electrónico?',
                sendEmailOneMoreTime: 'Envíe el correo electrónico una vez más',
                resendErrorTitle: 'Error durante la recuperación de la contraseña',
                resendErrorMessage:
                    'No se ha podido enviar el correo electrónico de recuperación de la contraseña. ¿Tal vez se equivocó de correo electrónico?',
            },
        },

        termsAndConds: {
            termsAndConditions: 'Términos y condiciones',
            privacyPolicy: 'Política de privacidad',
            talentPanel: '¿Escuela/Empleador?',
        },
        favoriteModule: {
            favoriteCard: {
                deleted: 'Borrado',
                deletedTitle: 'Este puesto ya no está disponible',
            },
        },
        pageNotFound: {
            header: '404',
            description: 'Parece que la página que buscaba ya no está aquí.',
            goToHome: 'Ir a la página de inicio',
            contactus: 'Contáctenos',
        },
        chat: {
            liveNow: '¡En vivo en el chat ahora!',
            seeAll: 'Todo',
            schoolSpecificChats: 'Acceso rápido',
            help: '¿Necesita ayuda?',
            chatExistsLabel: 'El chat existe',
        },
        countdown: {
            day: 'día',
            days: 'días',
            hour: 'hora',
            hours: 'horas',
            minute: 'minuto',
            minutes: 'minutos',
            second: 'segundo',
            seconds: 'segundos',
        },
    },
    spotlight: {
        header: 'Mi perfil',
        saveChangesToSubmit: 'Guarde su perfil para que los cambios surtan efecto',
        saveChanges: 'Guardar los cambios',
        saveSuccessful: 'Sus cambios se han guardado correctamente',
        personalDetails: {
            header: 'Datos personales',
            firstName: 'Nombre',
            lastName: 'Apellido',
            nationality: 'Nacionalidad',
            gender: 'Género',
            uploadProfileImage: 'Subir foto',
            genderOptions: {
                male: 'Hombre',
                female: 'Mujer',
                other: 'Otro',
                none: 'Prefiero no decirlo',
                unknown: 'Desconocido',
            },
            wrongFileTypeErrorHeader: 'Tipo de archivo no válido',
            wrongFileTypeErrorDescription: 'Sólo puede subir imágenes',
        },
        summary: { header: 'Resumen ejecutivo' },
        contactDetails: {
            header: 'Datos de contacto',
            contactEmail: 'Correo electrónico de contacto',
            phoneNumberHeader: 'Número de teléfono móvil',
            countryCode: 'Código de país',
            phoneNumber: 'Número de teléfono',
            invalidEmail: 'El correo electrónico escrito no es un correo electrónico válido.',
            permanentEmail:
                'NOTA: Este cambio es permanente. Sólo puede establecer su correo electrónico una vez.',
        },
        languages: {
            header: 'Idiomas',
            languageLabel: 'Idioma',
            levelLabel: 'Nivel',
            addLanguage: 'Añadir nuevo idioma',
            proficiencies: {
                '22f882cc-3cb0-4cfd-a590-ef010f4d798b': 'Dominio elemental',
                '82edcac6-693b-42ea-bf24-0a52774f395c': 'Competencia laboral limitada',
                'a97f6798-7280-4ce7-8896-6d4a8fb58c63': 'Competencia profesional',
                '93b37709-3f2d-4853-ac77-b8c0dd07243e': 'Competencia profesional completa',
                '250d296e-d6db-46fb-8c44-07950db80ec4': 'Competencia nativa o bilingüe',
            },
        },
        education: {
            header: 'Educación',
            addEducation: 'Añadir educación',
            notGraduated: 'No se ha graduado todavía',
            graduatedIn: 'Graduado en {date}',
            dialog: {
                addNewEducation: 'Añadir nueva educación',
                degreeTitle: 'Programa',
                institution: 'Institución',
                degreeType: 'Título',
                fieldOfStudy: 'Campo de estudio',
                cannotFindField: 'No encuentro mi campo',
                studyStart: 'Mes de inicio',
                studyEnd: 'Mes de graduación',
                invalidDegreeTitle: 'Necesita rellenar el título de su programa.',
                invalidSchool: 'Necesita seleccionar una escuela.',
                invalidStartDate: 'Por favor, seleccione una fecha de inicio.',
                invalidEndDate: 'Por favor, seleccione una fecha de graduación.',
                invalidStudyPeriod: 'No puede graduarse antes de la fecha de inicio.',
                invalidDegreeField: 'Por favor, introduzca un campo de estudio válido.',
                invalidDegreeLevel: 'Por favor, seleccione un nivel válido de su titulación.',
                selectStartDate: 'Fecha de inicio',
                selectEndDate: 'Fecha de graduación',
                degrees: {
                    '5b468395-7bf7-4f14-88d9-32096884d4ef': 'Licenciatura',
                    '09f419fa-1517-41ce-970c-df0d073fc440': 'Máster',
                    '2c917ed6-5bb7-4e23-95ab-60c55d8df135': 'MBA',
                    '1fff1451-f07c-415c-954a-63b1e5f44fc8': 'DBA',
                    '2fbd6155-d939-40cc-970d-283be0aef433': 'PHD',
                },
                diciplins: {
                    '383c2086-24da-4fe2-977b-7e3d4da85f8e': 'Agricultura y silvicultura',
                    'c8fb1348-bdac-4ed3-af7a-a831376d04b7': 'Ciencias Aplicadas y Profesiones',
                    '5c665d94-5124-4226-a4f6-da8cca47e3f6': 'Arte, Diseño y Arquitectura',
                    '06b028e2-d7ed-4281-8668-1009d6da1c35': 'Negocios y Gestión',
                    '747624bb-0174-4961-a3c0-dbe4f1cb750d': 'Informática y TI',
                    'ede2bbdb-7a1d-466c-99e5-bcab52e07d69': 'Economía',
                    '5c0432d4-9297-429a-85c4-3305d207764e': 'Educación y Formación',
                    '8198b6ea-5b28-4be2-afbc-45df759c65cb': 'Ingeniería y Tecnología',
                    '7e5c0527-d1ec-4125-945e-138ec473e8dd':
                        'Estudios Medioambientales y Ciencias de la Tierra',
                    '3babe28b-6285-4a03-b0b8-43f55be393cd': 'Hostelería, Ocio y Deportes',
                    '9eebcc51-385e-4122-88a1-6dd3efbaf896': 'Humanidades',
                    '390cf111-b55a-4bb7-a6b6-1cc2b21a248f': 'Periodismo y Medios de Comunicación',
                    'a2744908-9521-4330-a07d-3680b058d0a6': 'Derecho',
                    '947993e1-b723-4d85-8cd9-a4ae46cd623e': 'Marketing',
                    'c98802c8-74a5-4a98-99ba-84eb76fd1a60': 'Máster en Innovación y Negocios',
                    'bca263cc-3d17-4ad8-b70e-e2bfe04421fa': 'Máster en Gestión del Desarrollo',
                    'a37667e2-5713-4157-82e9-78c10760d2de': 'Máster en Ciencias de la Información',
                    '72277bb7-9d5e-422a-a2b4-8a8fb8be7143': 'Medicina y Salud',
                    'bd84a8cd-ce66-4c61-86a8-7fcb6644cc5d': 'Maestría en Finanzas',
                    '9e665ac9-9611-4508-af4b-22e91f167ea4':
                        'MS en Estudios de Negocios Internacionales',
                    'baf5bb0a-d0ab-4c13-aacc-c6a8a90e2fcf': 'Maestría en Análisis de Negocios',
                    '7d832109-642a-4730-aada-26927eb683ee': 'Máster en Gestión',
                    'baf05a5a-faba-4f30-9254-9cd73bb63bbf': 'Ciencias Naturales y Matemáticas',
                    '828cc4ac-1f2b-4133-8e29-ba1347585ae6': 'Ciencias Sociales',
                    '44c1f8cf-8696-4638-bc03-9763c2de32af': 'Otros',
                },
            },
        },
        workAuthorization: {
            header: 'Autorización de trabajo',
            addWorkAuthorization: 'Añadir autorización de trabajo',
            implicitValue: 'Según su nacionalidad',
            dialog: {
                selectCountry: 'Seleccione el país',
                addEuWorkAuthorization: 'Añadir autorización de trabajo de la UE',
            },
        },
        communication: {
            header: 'Comunicación',
            sendMeUpdatesDescription:
                'Por favor, envíenme por correo electrónico noticias sobre mi carrera, puestos de trabajo y actualizaciones de la empresa',
        },
        errors: {
            imageUpload: {
                title: 'No se ha podido cargar la imagen.',
                message: '¡La imagen es demasiado grande!',
            },
        },
        exitDialog: {
            title: 'Los cambios no guardados se perderán',
            message:
                'Está intentando salir de la página sin guardar los cambios. ¿Desea guardar su perfil antes de seguir adelante?',
            stayAction: 'Permanezca en esta página',
            saveAction: 'Guardar el perfil',
            continueAction: 'Continuar sin guardar',
        },
    },
    tests: {
        header: 'Pruebas',
        unauthorized:
            'Las pruebas están actualmente en beta cerrada. Todavía no tiene acceso a estas funciones, ¡pronto estarán disponibles!',
        error: 'Algo ha ido mal al intentar cargar las pruebas. Por favor, inténtelo de nuevo más tarde.',
        assessmentModule: { header: 'Su evaluación' },
        completedYourProfile: 'Necesita completar su perfil para tener acceso a esta evaluación',
        toMyProfile: 'Editar mi perfil',
    },
    vfair: {
        header: 'Eventos virtuales de la EFMD',
        activeNow: 'En curso',
        visibilityPrivate: 'Privado',
        visibilityNetwork: 'Red',
        visibilityOpen: 'Abrir',
        interested: 'Inscríbase en',
        attend: 'Asistir al evento',
        enterEvent: 'Entrar en el evento virtual',
        notinterested: 'Ya no estoy interesado',
        shownInterest: 'Registrado',
        signUpToday: '¡Inscríbase hoy mismo!',
        vfairsInfo:
            'Conecte con empresas y organizaciones de todo el mundo, en un sofisticado entorno de simulación de feria de empleo que permite la interacción en tiempo real entre reclutadores y candidatos. Haga clic en el evento virtual que le interese y regístrese para recibir notificaciones.',
        recruitingOrgs: 'Empresas y Organizaciones de Contratación',
        preRegistered: 'Preinscritos',
        prepareForTheFair: 'Prepare el evento virtual',
        privateVFairHeader: 'Evento virtual en el campus',
        privateVFairMessage:
            'Este evento virtual está alojado en la plataforma de una escuela de la EFMD, por lo que no se puede acceder a él desde aquí.',
        schoolNotJoinedNetworkEventMessage:
            'Su escuela aún no se ha inscrito en este evento virtual, póngase en contacto con el director de su programa o con el departamento de carreras profesionales para solicitar su participación.',
        companyNotJoinedNetworkEventMessage:
            'Su organización no tiene un stand virtual activo en este evento. Póngase en contacto con Highered para solicitar su participación.',
        pavilions: 'Pabellones',
        general: 'General',
        allCompanies: 'Todas las empresas',
        lobby: 'Vestíbulo',
        inviteCode: 'Código de invitación',
        eventRequiresInvitation: 'Este evento requiere una invitación',
        haveCode: 'Tengo un código',
        checkCode: 'Comprobar código',
        invalidCode: 'Código inválido',
        registeredSuccessfully: 'Registrado con éxito',
        pavilionTabs: {
            home: 'Inicio',
            companies: 'empresas',
            articles: 'artículos',
            jobs: 'empleos',
            events: 'eventos',
        },
        events: {
            noEventsAvailable: 'No hay eventos disponibles',
            showCompleted: 'Mostrar completado',
            hideCompleted: 'Ocultar completado',
            liveNow: 'En vivo ahora',
            joinTheEvent: 'Únase al evento',
            addToCalendar: 'Añadir al calendario',
        },
        links: {
            masterclasses: {
                header: 'Clases magistrales',
                buttonCaption: 'Ver las clases magistrales',
                description:
                    'Vea un amplio abanico de clases magistrales de gran calidad, como "Optimización del CV para Ser Contratado", "Mejore su Perfil de Linkedin" y "Negociación Salarial", entre muchas otras, ¡para todas las etapas de su trayectoria profesional',
            },
            detailsmasterclass: { header: 'Asistir a la clase magistral' },
            cv: {
                header: 'Plantilla de CV',
                buttonCaption: 'Descargue la plantilla de CV',
                description:
                    'Acceda a la plantilla de CV de Highered, apta para ATS, para causar una óptima impresión profesional con los reclutadores.',
            },
            elevatorPitch: {
                header: 'Reto del Elevator Pitch ',
                buttonCaption: 'Envíe su pitch',
                description:
                    '¡Acepte el "Desafío del Pitch Perfecto"! Esta es su oportunidad de presentar su valor a cientos de reclutadores de las principales empresas y organizaciones mundiales',
            },
        },
        footerHeaders: {
            social: 'Síganos para más actualizaciones',
            sponsored: 'Patrocinado por',
            organized: 'Organizado por',
        },
        educationPopup: {
            step00: {
                header: 'Comparta su educación',
                subtitle: 'Para continuar, deje que los empleadores sepan más sobre usted',
                continueLabel: 'Añadir mi educación',
                leaveLabel: 'Descartar',
            },
            step01: { header: 'Díganos su educación' },
            step02: { loadingLabel: 'Un momento...' },
            step03: {
                header: 'Educación completada',
                subtitle:
                    'Ahora puede compartir su perfil y ser más interesante entre los empleadores',
                continueLabel: 'Continúe explorando el evento virtual',
            },
            error: {
                header: '¡Wops! ¡Se ha producido un error!',
                subtitle:
                    'No hemos podido almacenar su información educativa. Por favor, inténtelo de nuevo más tarde.',
            },
        },
    },
};
